module.exports = __webpack_public_path__ + "img/46.8.TSS.c900f25d.png";